const EditorCloseSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M7.99948 9.06401L4.27363 12.7899C4.13423 12.9293 3.95681 12.999 3.74137 12.999C3.52593 12.999 3.34851 12.9293 3.2091 12.7899C3.0697 12.6505 3 12.473 3 12.2576C3 12.0421 3.0697 11.8647 3.2091 11.7253L6.93495 7.99948L3.2091 4.27363C3.0697 4.13423 3 3.95681 3 3.74137C3 3.52593 3.0697 3.34851 3.2091 3.2091C3.34851 3.0697 3.52593 3 3.74137 3C3.95681 3 4.13423 3.0697 4.27363 3.2091L7.99948 6.93495L11.7253 3.2091C11.8647 3.0697 12.0421 3 12.2576 3C12.473 3 12.6505 3.0697 12.7899 3.2091C12.9293 3.34851 12.999 3.52593 12.999 3.74137C12.999 3.95681 12.9293 4.13423 12.7899 4.27363L9.06401 7.99948L12.7899 11.7253C12.9293 11.8647 12.999 12.0421 12.999 12.2576C12.999 12.473 12.9293 12.6505 12.7899 12.7899C12.6505 12.9293 12.473 12.999 12.2576 12.999C12.0421 12.999 11.8647 12.9293 11.7253 12.7899L7.99948 9.06401Z"
        fill="black"
      />
    </svg>
  );
};

export default EditorCloseSvg;
